import { cityMap } from './city'
import { pcaList } from './pca'
import { provinces } from './province'
import { PCA } from './type'

/**
 * 获取 antd Cascader 级联组件的省市数据
 * 目前仅返回省、市，区县根据情况后面再补充
 */
export function getCascaderOptionsForRegion() {
  return provinces.map(province => ({
    value: province.name,
    label: province.name,

    // @ts-ignore
    children: (cityMap[province.id] || []).map((city: string) => ({
      value: city,
      label: city,
    })),
  }))
}

/**
 * 省市县-三级联动
 */
export function getPcaRegionOption() {
  return pcaList.map((p) => ({
    label: p.name,
    value: p.name,
    children: p.children.map((c) => ({
      label: c.name,
      value: c.name,
      children: c.children.map((a) => ({
        label: a.name,
        value: a.name
      }))
    }))
  }))
}

export { provinces, cityMap }
